<template lang="pug">
button.v-link-widget.link-widget(v-if="widget" type="button" @click="scrollToTarget")
	img.link-widget__image(v-if="widget.image" :src="widget.image" loading="lazy")
	.link-widget__title(v-if="widget.title")
		v-svg-icon.link-widget__title-icon(icon="flower")
		.link-widget__title-text {{widget.title}}
</template>

<script>
export default {
	props: {
		widget: {
			type: Object,
			default: null
		}
	},

	methods: {
		scrollToTarget() {
			let $target = document.getElementById(this.widget.anchorId);
			console.log('$target', this.widget.anchorId)
			if (!$target) {
				return;
			}
			window.scrollTo({
				top: $target.offsetTop,
				behavior: 'smooth'
			});
		},
	}
};
</script>
